<script setup lang="ts">
import CounterRating from "./CounterRating.vue";
import LikeRating from "./LikeRating.vue";
import StarsRating from "./StarsRating.vue";
import type {
  AnyRatingServiceIncludingValue,
  CounterServiceIncludingValue,
  LikeServiceIncludingValue,
  StarsServiceIncludingValue,
  AnyValue,
} from "@/stores/ratingService";
import {
  isCounterServiceIncludingValue,
  isLikeServiceIncludingValue,
  isStarsServiceIncludingValue,
} from "@/stores/ratingService";

const props = withDefaults(
  defineProps<{
    rating: AnyRatingServiceIncludingValue;
    showButtons?: boolean;
  }>(),
  {
    showButtons: true,
  },
);

const emit = defineEmits<{
  (event: "set", newState: AnyValue, oldState: AnyValue): void;
}>();
</script>

<template>
  <CounterRating
    v-if="isCounterServiceIncludingValue(props.rating)"
    :rating="props.rating as CounterServiceIncludingValue"
    :show-buttons="props.showButtons"
    @set="(newState, oldState) => { console.log('HydrusRating.emit', ['set', newState, oldState]); emit('set', newState, oldState) }"
  />
  <LikeRating
    v-else-if="isLikeServiceIncludingValue(props.rating)"
    :rating="props.rating as LikeServiceIncludingValue"
    :show-buttons="props.showButtons"
    @set="(newState, oldState) => emit('set', newState, oldState)"
  />
  <StarsRating
    v-else-if="isStarsServiceIncludingValue(props.rating)"
    :rating="props.rating as StarsServiceIncludingValue"
    :show-buttons="props.showButtons"
    @set="(newState, oldState) => emit('set', newState, oldState)"
  />
  <div v-else>
    Unknown rating service:
    {{ JSON.stringify(props.rating) }}
  </div>
</template>

<style scoped></style>
